<template lang="pug">
.swiper-slide(:key="result.key")
    .video-player
        a.video-player__video(v-if="!isPlaylist" ref="video" @click.prevent="openDialog()" :data-video-embed-code="result.meta.videoembedcode" :data-video-title="result.title")
            img.video-player__thumbnail(v-if="result.image" :src="result.image" :alt="result.title")
            span.video-player__play
        a.video-player__video(v-else-if="isPlaylist" :target="openInNewWindow ? '_blank' : false", :href="result.url")
            img.video-player__thumbnail(v-if="result.image" :src="result.image" :alt="result.title")
        .video-player__copy
            p.video-player__title {{result.title}}
            template(v-if="showPlaylist && playlistLength")
                a.video-player__show-playlists(@click.prevent="togglePlaylists()") 
                    |{{showPlaylists ? 'Hide' : 'Show'}} Playlist{{playlistLength > 1 ? 's': ''}} [{{playlistLength}}] 
                .video-player__playlists(:style="showPlaylists ? {height: '' + ((20 * playlistLength) + 4) + 'px'} : null")
                    a.video-library__playlist-link(v-for="playlist in result.meta.playlists" :href="playlist.url" :key="playlist.id")
                        i.fas.fa-film(aria-hidden='')
                        | {{playlist.name}}
            p.video-player__description(v-html="shortDescription")
            a.video-player__link(v-if="!isPlaylist" :target="openInNewWindow ? '_blank' : false", :href="result.url" @click.prevent="openDialog()" :data-video-embed-code="result.meta.videoembedcode" :data-video-title="result.title") Watch Now
            a.video-player__link(v-else-if="isPlaylist" :target="openInNewWindow ? '_blank' : false", :href="result.url") View Playlist [{{playlistLength}}]
    //- we'll create a unique dialog but not render it until it's needed
    VideoLibraryResultsItemDialog(:result="result" v-if="dialogOpen" @close="dialogOpen = false")

</template>

<script>
import VideoLibraryResultsItemDialog from "./Dialog.vue";
export default {
    name: "VideoLibraryResultsItem",
    props: ["result", "formatDate", "openInNewWindow","searchSubmitted", "showPlaylist"],
    components: {VideoLibraryResultsItemDialog },
    computed: {
        date() {
            return this.formatDate(this.result.itemDate, "MMM dd, yyyy");
        },
        playlistLength() {
            return this.result.meta.playlists?.length || this.result.videos?.length;
        },
        isPlaylist() {
            return this.result.meta.type === "PlayList";
        },
        shortDescription() {
            return this.result.meta?.shortDescription || "";
        }
    },
    data () {
        return {
            dialogOpen: false,
            showPlaylists: false
        }
    },
    methods: {
        openDialog() {
            this.dialogOpen = true
        },
        togglePlaylists() {
            this.showPlaylists = !this.showPlaylists;
        }
    }
};
</script>

<style lang="scss" scoped>
.video-player {
    &__show-playlists {
        cursor: pointer;
        text-decoration: underline;
        color: $occGray !important;

        &:hover {
            color: darken($occGray, 20%) !important;
        }
    }
    &__playlists {
        height: 0;
        overflow: hidden;
        transition: height 0.25s ease;
    }
    &__link {
        color: $occGray !important;

        &:hover {
            color: darken($occGray, 20%) !important;
        }
    }
    &__description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    &__video {
        cursor: pointer;
    }
}
.video-library__playlist-link {
    margin: 0.125rem 0 0.125rem;
    line-height: 1rem;
    color: $occBlue !important;

    &:hover {
        color: darken($occBlue, 20%) !important;
    }
}
</style>